document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initAnuncios();
  initCarruseles();
  initResenasAuto();
  initGaleriaMovil();
  initFaq();
  initCartFx();
  initStickyOffset();
  initStockBarra();
  initViendoAhora();
  initEnvioGratisBarra();
  initReservaCarrito();
  initBotonPago();
});

function initReveal() {
  var els = document.querySelectorAll('.cr-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('cr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.dataset.crDelay || 0;
        setTimeout(function () { el.classList.add('cr-visible'); }, Number(delay));
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initStockBarra() {
  var els = document.querySelectorAll('.cr-stock-barra-relleno');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cr-stock-barra-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initEnvioGratisBarra() {
  var notification = document.getElementById('cart-notification');
  if (!notification) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rellenar() {
    var relleno = notification.querySelector('.cr-envio-gratis-barra-relleno');
    if (!relleno) return;
    relleno.classList.remove('cr-envio-gratis-barra-visible');
    if (reduceMotion) {
      relleno.classList.add('cr-envio-gratis-barra-visible');
      return;
    }
    void relleno.offsetWidth;
    relleno.classList.add('cr-envio-gratis-barra-visible');
  }

  function actualizarContador() {
    var contador = notification.querySelector('[data-cr-carrito-count]');
    var burbuja = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (contador && burbuja) contador.textContent = burbuja.textContent;
  }

  var observer = new MutationObserver(function () {
    if (notification.classList.contains('active')) {
      rellenar();
      actualizarContador();
    }
  });
  observer.observe(notification, { attributes: true, attributeFilter: ['class'] });
}

function initViendoAhora() {
  var els = document.querySelectorAll('[data-cr-viendo-ahora]');
  if (!els.length) return;
  var INICIO = 10;
  var MAXIMO = 22;
  var INCREMENTO = 2;
  var INTERVALO_SUBIDA_MS = 15000;
  var INTERVALO_CICLO_MS = 7000;
  // Al llegar al máximo, en vez de parar, oscila en bucle: -3, +2, -2, +3...
  var CICLO = [-3, 2, -2, 3];

  els.forEach(function (el) {
    var texto = el.querySelector('[data-cr-viendo-ahora-texto]');
    var contador = INICIO;
    var enCiclo = false;
    var pasoCiclo = 0;

    function pintar() {
      texto.textContent = contador + ' personas están viendo este producto ahora mismo';
    }

    function programarSiguiente() {
      var espera = enCiclo ? INTERVALO_CICLO_MS : INTERVALO_SUBIDA_MS;
      setTimeout(tick, espera);
    }

    function tick() {
      if (!enCiclo) {
        contador = Math.min(contador + INCREMENTO, MAXIMO);
        if (contador >= MAXIMO) enCiclo = true;
      } else {
        contador += CICLO[pasoCiclo];
        pasoCiclo = (pasoCiclo + 1) % CICLO.length;
      }
      pintar();
      programarSiguiente();
    }

    pintar();
    programarSiguiente();
  });
}

function initCarruseles() {
  // Delegado en document (en vez de enganchar cada botón al cargar la página):
  // el carrusel de "Completa tu look" lo inyecta Shopify por fetch más tarde
  // (product-recommendations), así que enganchar los botones al cargar la
  // página nunca los encontraba. Con delegación funciona sin importar cuándo
  // aparezca el carrusel en el DOM.
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-cr-carrusel-prev]');
    var nextBtn = e.target.closest('[data-cr-carrusel-next]');
    var btn = prevBtn || nextBtn;
    if (!btn) return;
    var wrap = btn.closest('.cr-resenas, .cr-clientas, .cr-carrusel-wrap');
    var track = wrap ? wrap.querySelector('[data-cr-carrusel]') : null;
    if (!track) return;
    var card = track.querySelector(':scope > *');
    var paso = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
    track.scrollBy({ left: prevBtn ? -paso : paso, behavior: 'smooth' });
  });
}

// Opiniones ("Lo que dicen nuestras clientas"): se mueven sin parar, despacio,
// hacia la derecha. Se duplican las tarjetas para que el bucle sea continuo.
// Se pausan al pasar el ratón / tocar y mientras no estén a la vista; no se
// activan con "reducir movimiento".
function initResenasAuto() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var VELOCIDAD = 30; // píxeles por segundo
  document.querySelectorAll('.cr-resenas-carrusel[data-cr-carrusel]').forEach(function (track) {
    var originales = Array.prototype.slice.call(track.children);
    if (originales.length < 2) return;
    originales.forEach(function (card) {
      var copia = card.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      copia.style.opacity = '1';
      copia.style.transform = 'none';
      track.appendChild(copia);
    });
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';

    var pos = track.scrollLeft, pausado = false, visible = false, ultimo = 0, reanudarT;
    function mitad() {
      var primera = track.children[0].getBoundingClientRect().left;
      var copiaPrimera = track.children[originales.length].getBoundingClientRect().left;
      return copiaPrimera - primera;
    }
    function pausar() { clearTimeout(reanudarT); pausado = true; }
    function reanudar() {
      clearTimeout(reanudarT);
      reanudarT = setTimeout(function () { pos = track.scrollLeft; pausado = false; }, 2500);
    }
    track.addEventListener('mouseenter', pausar);
    track.addEventListener('mouseleave', reanudar);
    track.addEventListener('touchstart', pausar, { passive: true });
    track.addEventListener('touchend', reanudar, { passive: true });
    track.addEventListener('focusin', pausar);
    track.addEventListener('focusout', reanudar);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(track);
    } else { visible = true; }

    function paso(t) {
      var dt = Math.min((t - ultimo) / 1000, 0.1);
      ultimo = t;
      if (!pausado && visible && !document.hidden) {
        pos += VELOCIDAD * dt;
        var m = mitad();
        if (m > 0 && pos >= m) pos -= m;
        track.scrollLeft = pos;
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  });
}

// Galería de producto en móvil: marca como activa (más grande) la foto más cercana al centro del carrusel.
function initGaleriaMovil() {
  var lista = document.querySelector('.product__media-list');
  if (!lista) return;
  var ticking = false;
  function marcar() {
    ticking = false;
    var items = lista.querySelectorAll('.product__media-item');
    if (!items.length) return;
    var ref = lista.getBoundingClientRect().left + parseFloat(getComputedStyle(lista).paddingLeft || 0);
    var mejor = null, dist = Infinity;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      var d = Math.abs(r.left - ref);
      if (d < dist) { dist = d; mejor = it; }
    });
    items.forEach(function (it) { it.classList.toggle('cr-activa', it === mejor); });
  }
  lista.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(marcar); }
  }, { passive: true });
  window.addEventListener('resize', marcar);
  marcar();
}

function initFaq() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.cr-faq-lista').forEach(function (lista) {
    var items = Array.prototype.slice.call(lista.querySelectorAll(':scope > .cr-faq-item'));
    if (!items.length) return;

    var state = items.map(function (details) {
      return {
        details: details,
        summary: details.querySelector('summary'),
        closedHeight: details.offsetHeight,
        animation: null,
        isClosing: false,
        isExpanding: false
      };
    });

    function finish(item, isOpen) {
      item.details.open = isOpen;
      item.animation = null;
      item.isClosing = false;
      item.isExpanding = false;
      item.details.style.height = '';
      item.details.style.overflow = '';
    }

    function shrink(item) {
      item.isClosing = true;
      item.details.style.overflow = 'hidden';
      var startHeight = item.details.offsetHeight + 'px';
      var endHeight = item.closedHeight + 'px';
      if (item.animation) item.animation.cancel();
      item.animation = item.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );
      item.animation.onfinish = function () { finish(item, false); };
      item.animation.oncancel = function () { item.isClosing = false; };
    }

    function expand(item) {
      item.isExpanding = true;
      var startHeight = item.details.offsetHeight + 'px';
      var endHeight = item.details.scrollHeight + 'px';
      if (item.animation) item.animation.cancel();
      item.animation = item.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );
      item.animation.onfinish = function () { finish(item, true); };
      item.animation.oncancel = function () { item.isExpanding = false; };
    }

    function openItem(item) {
      item.details.style.overflow = 'hidden';
      item.details.style.height = item.details.offsetHeight + 'px';
      item.details.open = true;
      window.requestAnimationFrame(function () { expand(item); });
    }

    state.forEach(function (item) {
      item.summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduceMotion) {
          item.details.open = !item.details.open;
          return;
        }
        var willOpen = item.isClosing || !item.details.open;
        if (willOpen) {
          state.forEach(function (other) {
            if (other !== item && (other.details.open || other.isExpanding)) {
              shrink(other);
            }
          });
          openItem(item);
        } else {
          shrink(item);
        }
      });
    });
  });
}

function initCartFx() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var ultimoBoton = null;

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM' || !form.closest('product-form')) return;
    ultimoBoton = form.querySelector('[type="submit"]');
  }, true);

  var cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    var pulsar = function () {
      var bubble = cartIcon.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('cr-cart-bubble-pulso');
      void bubble.offsetWidth;
      bubble.classList.add('cr-cart-bubble-pulso');
      setTimeout(function () { bubble.classList.remove('cr-cart-bubble-pulso'); }, 650);
    };
    new MutationObserver(pulsar).observe(cartIcon, { childList: true, subtree: true });
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
    if (evt && evt.source !== 'product-form') return;
    var boton = ultimoBoton;
    if (!boton) return;
    boton.classList.remove('cr-boton-anadido');
    void boton.offsetWidth;
    boton.classList.add('cr-boton-anadido');
    setTimeout(function () { boton.classList.remove('cr-boton-anadido'); }, 550);
  });
}

function initStickyOffset() {
  var header = document.querySelector('.header');
  var countdown = document.querySelector('.cr-cuenta-atras');
  if (!header && !countdown) return;

  function setOffset() {
    var height = (header ? header.offsetHeight : 0) + (countdown ? countdown.offsetHeight : 0);
    document.documentElement.style.setProperty('--cr-sticky-offset', height + 'px');
  }

  // La cabecera ahora es fija siempre: el contador se pega justo debajo de ella.
  var cabecera = document.querySelector('.section-header');
  function setAltoCabecera() {
    if (!cabecera) return;
    document.documentElement.style.setProperty('--cr-header-alto', cabecera.offsetHeight + 'px');
  }

  setOffset();
  setAltoCabecera();
  window.addEventListener('resize', function () { setOffset(); setAltoCabecera(); });
  window.addEventListener('load', function () { setOffset(); setAltoCabecera(); });
  if (cabecera && 'ResizeObserver' in window) {
    new ResizeObserver(function () { setOffset(); setAltoCabecera(); }).observe(cabecera);
  }
}

function initAnuncios() {
  var wraps = document.querySelectorAll('[data-cr-anuncios]');
  wraps.forEach(function (wrap) {
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-cr-anuncio]'));
    if (items.length < 2) return;
    var duration = Number(wrap.dataset.crDuracion || 4000);
    var current = 0;
    items.forEach(function (item, i) { item.classList.toggle('cr-anuncio-activo', i === 0); });
    setInterval(function () {
      var next = (current + 1) % items.length;
      items[current].classList.remove('cr-anuncio-activo');
      items[next].classList.add('cr-anuncio-activo');
      current = next;
    }, duration);
  });
}

function initReservaCarrito() {
  var CLAVE = 'cr_reserva_fin';
  var DURACION_MS = 10 * 60 * 1000;
  var URGENTE_MS = 60 * 1000;

  function leerFin() {
    try { return Number(localStorage.getItem(CLAVE)) || 0; } catch (e) { return 0; }
  }
  function guardarFin(valor) {
    try {
      if (valor) localStorage.setItem(CLAVE, String(valor));
      else localStorage.removeItem(CLAVE);
    } catch (e) {}
  }

  var finMemoria = leerFin();

  function pintar() {
    var avisos = document.querySelectorAll('[data-cr-reserva]');
    if (!avisos.length) return;
    var fin = leerFin() || finMemoria;
    var restante = fin - Date.now();
    if (restante <= 0) {
      if (fin) { guardarFin(0); finMemoria = 0; }
      avisos.forEach(function (el) { el.hidden = true; });
      return;
    }
    var seg = Math.ceil(restante / 1000);
    var texto = String(Math.floor(seg / 60)).padStart(2, '0') + ':' + String(seg % 60).padStart(2, '0');
    avisos.forEach(function (el) {
      var tiempo = el.querySelector('[data-cr-reserva-tiempo]');
      if (tiempo) tiempo.textContent = texto;
      el.classList.toggle('cr-reserva-carrito--urgente', restante <= URGENTE_MS);
      el.hidden = false;
    });
  }

  function reiniciar() {
    finMemoria = Date.now() + DURACION_MS;
    guardarFin(finMemoria);
    pintar();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'product-form') reiniciar();
    });
  }

  pintar();
  setInterval(pintar, 1000);
}

// El botón de pago rápido ("Comprar ahora") lo pinta Shopify con JavaScript y su texto no se puede
// cambiar desde el tema; aquí se reescribe cada vez que Shopify lo vuelve a pintar.
function initBotonPago() {
  var TEXTO = 'Pagar de forma segura';
  var ORIGINAL = /^\s*(comprar ahora|buy it now|buy now)\s*$/i;
  var pendiente = false;

  function reescribir() {
    pendiente = false;
    document.querySelectorAll('.shopify-payment-button__button').forEach(function (boton) {
      var walker = document.createTreeWalker(boton, NodeFilter.SHOW_TEXT);
      var nodo;
      while ((nodo = walker.nextNode())) {
        if (ORIGINAL.test(nodo.nodeValue)) nodo.nodeValue = TEXTO;
      }
    });
  }

  function programar() {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(reescribir);
  }

  new MutationObserver(function (mutaciones) {
    for (var i = 0; i < mutaciones.length; i++) {
      var objetivo = mutaciones[i].target;
      var el = objetivo.nodeType === 1 ? objetivo : objetivo.parentElement;
      if (el && (el.closest('.shopify-payment-button') || el.querySelector('.shopify-payment-button'))) {
        programar();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  reescribir();
}
